import { useUserStore } from 'user-store';

export const useAdminVisible = () => {
	const { user } = useUserStore();

	return user?.currentUserGroup?.isZitaraAdminUserGroup === true;
};
